import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import { formatThousandsDot } from "helpers/FormatNumbersWithComma";

// İlan oluşturulurken konutun gerçek metrekaresi girilir (tek sayı).
// Redux: newAdvert.filters.m2 (düz sayı). Görüntüde binlik nokta ayracı.
function FLM2Input(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const value = formatThousandsDot(filters?.m2 ?? "");

  return (
    <TextField
      type="text"
      inputMode="numeric"
      label={props.filter.title || "m² (Brüt)"}
      variant="outlined"
      margin="dense"
      fullWidth
      value={value}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, "");
        props.editNewAdvertFilters("m2", digits === "" ? "" : Number(digits));
      }}
      InputProps={{ endAdornment: <InputAdornment position="end">m²</InputAdornment> }}
    />
  );
}

export default connect(null, { ...advertRedux.actions })(FLM2Input);
